export default {
  method_unavailable: 'Deze betaalmethode is momenteel niet beschikbaar. Kies een andere.',
  payment_option_unavailable: 'Deze betaalmethode is momenteel niet beschikbaar. Kies een andere manier om te betalen.',
  online_payment_unavailable: 'Online betalen is momenteel niet beschikbaar. Probeer het zo meteen opnieuw.',
  retry_payment_methods: 'Probeer opnieuw',
  payment_not_ready: 'Je betaling wordt nog voorbereid. Probeer het zo opnieuw.',
  wallet_total_changed: 'Het totaal voor deze betaalmethode is gewijzigd. Controleer het en tik opnieuw op de knop.',
  wallet_tap_above: 'Tik hierboven op de knop {{method}} om te betalen, of kies een andere betaalmethode.',
  wallet_pay_above: 'Gebruik de {{method}}-knop hierboven',
  element_incomplete: 'Vul je betaalgegevens in om door te gaan.',
  element_incomplete_card: 'Controleer je kaartgegevens en probeer het opnieuw.',
  element_incomplete_bank: 'Kies je bank om door te gaan.',
  element_incomplete_sepa_debit: 'Controleer je IBAN en de gegevens van de rekeninghouder om door te gaan.',
};
